import React from 'react';
import './App.css';
import Dashboard from './components/dashboard/Dashboard';
import { BrowserRouter as Router } from 'react-router-dom';

// DEV-ONLY reproductive-node fixture viewer (Track A QA harness). Defined at module
// scope so the lazy chunk is only referenced inside the import.meta.env.DEV branch —
// Vite statically replaces import.meta.env.DEV with false in a production build, so
// this ternary (and the dynamic import) are dead-code-eliminated and never shipped.
const ReproFixtureViewer = import.meta.env.DEV
  ? React.lazy(() =>
      import('./components/pedigree-chart/dev/ReproFixtureViewer')
    )
  : null;

function App() {
  // Reachable only at /__repro-demo on the dev server; bypasses auth + the main
  // router so the Bennett fixtures can be eyeballed without the backend/editor.
  if (import.meta.env.DEV && window.location.pathname === '/__repro-demo') {
    return (
      <React.Suspense fallback={null}>
        <ReproFixtureViewer />
      </React.Suspense>
    );
  }

  return (
    <Router basename={process.env.PUBLIC_URL || '/'}>
      <div className="App">
        <Dashboard />
      </div>
    </Router>
  );
}

export default App;
